import { Autocomplete, Box, Button, CircularProgress, Icon, MenuItem, Paper, Select, TextField, useTheme } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { FazendaService } from '../../services/api/cadastros/FazendaService';
import { useDebounce } from '../../hooks';
import { ParceirosService } from '../../services/api/cadastros/ParceirosService';
interface IDadosSelect {
  nameBD: string;
  descricao: string;
}

type TAutoCompleteOption = {
  idfazenda: string;
  label: string;
}

type TAutoCompleteOptionParceiro = {
  idparceiro: string;
  label: string;
}

interface IFerramentasDaListagemProps {
  dadosSelecao?: IDadosSelect[];
  dataInicial?: string;
  dataFinal?: string;
  mostrarInputData?: boolean;
  mostrarInputFazenda?: boolean;
  mostrarInputParceiro?: boolean;
  aoMudarDataInicial?: (novoTexto: string) => void;
  aoMudarDataFinal?: (novoTexto: string) => void;
  aoMudarFazenda?: (novoTexto: string) => void;
  aoMudarParceiro?: (novoTexto: string) => void;
  textoBotaoNovo?: string;
  mostrarBotaoNovo?: boolean;
  aoClicarEmNovo?: () => void;
  mostrarInputBasicSelect?: boolean
  textoDoSelect?: string;
  aoMudarTextoDoSelect?: (novoTextoselect: string) => void;
}
export const FerramentasDaListagemSaida: React.FC<IFerramentasDaListagemProps> = ({
  dataInicial = '',
  aoMudarDataInicial,
  dataFinal = '',
  aoMudarDataFinal,
  aoMudarFazenda,
  aoMudarParceiro,
  mostrarInputData = false,
  mostrarInputFazenda = false,
  mostrarInputParceiro = false,
  aoClicarEmNovo,
  textoBotaoNovo = 'Novo',
  mostrarBotaoNovo = true,
  dadosSelecao =[],
  mostrarInputBasicSelect = false,
  textoDoSelect = '',
  aoMudarTextoDoSelect,
}) => {
  const theme = useTheme();
  const partesDaDataInicial = dataInicial.split('/');
  const dataInicialFormatada = partesDaDataInicial[2] + '-' + partesDaDataInicial[1] + '-' + partesDaDataInicial[0];

  const partesDaDataFinal = dataFinal.split('/');
  const dataFinalFormatada = partesDaDataFinal[2] + '-' + partesDaDataFinal[1] + '-' + partesDaDataFinal[0];


  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>();

  const [selectedIdParceiro, setSelectedIdParceiro] = useState<string | undefined>();

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [opcoesparceiros, setOpcoesParceiros] = useState<TAutoCompleteOptionParceiro[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');
  const [buscaparceiros, setBuscaParceiros] = useState('');

  useEffect(() => {
    setIsLoading(true);

    debounce(() => {
      FazendaService.getAlllist(selectedId, busca)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(fazenda => ({ idfazenda: fazenda.idfazenda, label: fazenda.descricao })));
          }
        });
    });
  }, [busca, selectedId]);

  useEffect(() => {
    setIsLoading(true);

    debounce(() => {
      ParceirosService.getAllList(buscaparceiros, selectedIdParceiro)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoesParceiros(result.data.map(parceiro => ({ idparceiro: parceiro.idparceiro, label: parceiro.nome })));
          }
        });
    });
  }, [buscaparceiros, selectedIdParceiro]);


  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idfazenda === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);

  const autoCompleteSelectedParceiro = useMemo(() => {
    if (!selectedIdParceiro) return null;

    const selectedOptionParceiro = opcoesparceiros.find(opcoesparceiros => opcoesparceiros.idparceiro === selectedIdParceiro);
    if (!selectedOptionParceiro ) return null;

    return selectedOptionParceiro;
  }, [selectedIdParceiro, opcoesparceiros]);

  return (
    <Box
      gap={1}
      marginX={3}
      paddingX={2}
      display="flex"
      alignItems="center"
      height={theme.spacing(5)}
      component={Paper}
      sx={{ height: '60px' }}
    >
      {mostrarInputBasicSelect && (
        <Select
          size="small"
          sx={{ minWidth: 170 }}
          value={textoDoSelect}
          onChange={(event) => aoMudarTextoDoSelect?.(event.target.value)}
        >
          {dadosSelecao.map((item) => (
            <MenuItem key={item.nameBD} value={item.nameBD}>
              {item.descricao}
            </MenuItem>
          ))}
        </Select>
      )}

      {mostrarInputFazenda && (
        <Autocomplete
          sx={{ minWidth: 250}}
          openText='Abrir'
          closeText='Fechar'
          noOptionsText='Sem opções'
          loadingText='Carregando...'
  
          disablePortal
  
          options={opcoes}
          loading={isLoading}
          value={autoCompleteSelectedOption}
          onInputChange={(_, newValue) => setBusca(newValue)}
          onChange={(_, newValue) => { setSelectedId(newValue?.idfazenda); aoMudarFazenda?.(newValue?.idfazenda || ''); setBusca('');}}
          popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              label="Fazenda"
            />
          )}
        />
      )}

      {mostrarInputParceiro && (
        <Autocomplete
          sx={{ minWidth: 400}}
          openText='Abrir'
          closeText='Fechar'
          noOptionsText='Sem opções'
          loadingText='Carregando...'
  
          disablePortal
  
          options={opcoesparceiros}
          loading={isLoading}
          value={autoCompleteSelectedParceiro}
          onInputChange={(_, newValue) => setBuscaParceiros(newValue)}
          onChange={(_, newValue) => { setSelectedIdParceiro(newValue?.idparceiro); aoMudarParceiro?.(newValue?.idparceiro || ''); setBuscaParceiros('');}}
          popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              label="Parceiros"
            />
          )}
        />
      )}

      {mostrarInputData && (

        <LocalizationProvider  dateAdapter={AdapterDayjs}>
        
          <DatePicker 
            sx={{ minWidth: 150, maxWidth: 150 }}
            label="Data Inicial" 
            format='DD/MM/YYYY'
            defaultValue={dayjs()}
            value={dayjs(dataInicialFormatada)}
            onChange={(date: Dayjs | null) => {
              const novoTexto = date ? date.format('DD/MM/YYYY') : '';
              aoMudarDataInicial?.(novoTexto);
            }}
            slotProps={{
              textField: {    
                size:'small',
              }
            }}
          />

          <DatePicker 
            sx={{ minWidth: 150, maxWidth: 150}}
            label="Data Final" 
            format='DD/MM/YYYY'
            defaultValue={dayjs()}
            value={dayjs(dataFinalFormatada)}
            onChange={(date: Dayjs | null) => {
              const novoTexto = date ? date.format('DD/MM/YYYY') : '';
              aoMudarDataFinal?.(novoTexto);
            }}
            slotProps={{
              textField: {    
                size:'small',
              }
            }}
          />
      
        </LocalizationProvider>
      )} 
      
      <Box flex={1} display="flex" justifyContent="end">
        {mostrarBotaoNovo && (
          <Button
            color='primary'
            disableElevation
            variant='contained'
            onClick={aoClicarEmNovo}
            endIcon={<Icon>add</Icon>}
          >{textoBotaoNovo}</Button>
        )}
      </Box>
    </Box>
  );
};